import Symbol from "./Symbol";
import { INSPECTOR_BUS } from "../../../constants/inspectorConstants";

class Bus extends Symbol {
    constructor({ alias, svgSrc, label, rotable, handles, type = "Bus"}) {
        super(type, { alias, svgSrc, label, rotable, handles });

        this.attributes = {
            ...this.attributes,
            brand: { isVisible: false, value: null, label: "Marca" },
            model: { isVisible: false, value: null, label: "Modelo" },
            ratedVoltage: { isVisible: false, value: null, label: "Voltaje nominal" },
            ratedCurrent: { isVisible: false, value: null, label: "Corriente Nominal" },
            shortcircuitCapacity: { isVisible: false, value: null, label: "Capacidad de cortocircuito" },
            length: { isVisible: false, value: null, label: "Longitud" },
        };                
    }

    getInspector() {
        return INSPECTOR_BUS;
    }
}

export default Bus;
